import './MessageTypeSelectionButtons.scss'
import {i18n} from "../../../Utils/i18n/i18n";
import {FeatureFlags, MessageTypes} from "../../../Utils/Constants";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import {WhatsAppIcon} from "../../../Utils/SVGs/WhatsAppIcon";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import React, {useContext, useEffect} from "react";
import {CompanyReactContext} from "../../../contexts/CompanyContext";
import {get} from "lodash";


const showWhatsApp = ({companyContext, excludeMessageTypes, isSuperAdmin}) => {
    return isSuperAdmin || (get(companyContext, `featureFlags[${FeatureFlags.WHATSAPP}]`) && !excludeMessageTypes.includes(MessageTypes.WHATSAPP))
}
const showSMS = ({companyContext, excludeMessageTypes, isSuperAdmin}) => {
    return isSuperAdmin || (get(companyContext, `featureFlags[${FeatureFlags.SMS}]`) && !excludeMessageTypes.includes(MessageTypes.SMS))
}
const showEmail = ({companyContext, excludeMessageTypes, isSuperAdmin}) => {
    return isSuperAdmin || (get(companyContext, `featureFlags[${FeatureFlags.EMAIL}]`) && !excludeMessageTypes.includes(MessageTypes.EMAIL))

}

/**
 * Component for selecting messaging types (SMS, WhatsApp, Email)
 * @param {Object} props - Component props
 * @param {Function} props.onSelectedMessageTypeChange - Callback when a message type button is clicked. Receives the clicked type string.
 * @param {Array} props.selectedMessagingTypes - Array of currently selected message types
 * @param {Array} props.excludeMessageTypes - Message types to exclude from display
 * @param {boolean} props.isSuperAdmin - Whether user is super admin
 */
export const MessageTypeSelectionButtons = ({onSelectedMessageTypeChange, selectedMessagingTypes=[], excludeMessageTypes=[], isSuperAdmin=false}) => {
    const companyContext = useContext(CompanyReactContext)
    useEffect(() => {
        if (isSuperAdmin) {
            return
        }
        //if selectedMessagingType is allowd by feature flags, leave it as is
        if (get(companyContext, `featureFlags[${FeatureFlags.SMS}]`) && selectedMessagingTypes.includes(MessageTypes.SMS) ||
            get(companyContext, `featureFlags[${FeatureFlags.WHATSAPP}]`) && selectedMessagingTypes.includes(MessageTypes.WHATSAPP) ||
            get(companyContext, `featureFlags[${FeatureFlags.EMAIL}]`) && selectedMessagingTypes.includes(MessageTypes.EMAIL)) {
            return
        }
        //check featureFlags, if SMS valid, set SMS as default, if not, check for WhatsApp, if valid, set WhatsApp as default, if not, set Email as default
        if (get(companyContext, `featureFlags[${FeatureFlags.SMS}]`)) {
            onSelectedMessageTypeChange(MessageTypes.SMS)
        } else if (get(companyContext, `featureFlags[${FeatureFlags.WHATSAPP}]`)) {
            onSelectedMessageTypeChange(MessageTypes.WHATSAPP)
        } else if (get(companyContext, `featureFlags[${FeatureFlags.EMAIL}]`)){
            onSelectedMessageTypeChange(MessageTypes.EMAIL)
        }
    }, []);
    const isSMSValid = showSMS({companyContext, excludeMessageTypes, isSuperAdmin})
    const isWhatsAppValid = showWhatsApp({companyContext, excludeMessageTypes, isSuperAdmin})
    const isEmailValid = showEmail({companyContext, excludeMessageTypes, isSuperAdmin})

    return <div className="MessageTypeSelectionButtons">
        {isSMSValid || isWhatsAppValid || isEmailValid || isSuperAdmin ? <div className="smsTitle">{i18n.translate('sendSMSModal.selectMessageDeliveryWay')}</div> : ''}
        <div className="messageTypeWrapper">
            {isSMSValid || isSuperAdmin ? <div onClick={() => onSelectedMessageTypeChange(MessageTypes.SMS)}
                  className={`messageTypeButton ${selectedMessagingTypes.includes(MessageTypes.SMS) ? 'selected' : ''}`}>
                <div className="messageTypeIcon">{<SmsOutlinedIcon width="36px" height="36px"/>}</div>
                <div className="messageTypeText">{i18n.translate('sendSMSModal.sms')}</div>
            </div> : ''}
            {isWhatsAppValid || isSuperAdmin ? <div onClick={() => onSelectedMessageTypeChange(MessageTypes.WHATSAPP)}
                 className={`messageTypeButton ${selectedMessagingTypes.includes(MessageTypes.WHATSAPP) ? 'selected' : ''}`}>
                <div className="messageTypeIcon">{<WhatsAppIcon width="32px" height="32px"/>}</div>
                <div className="messageTypeText">{i18n.translate('sendSMSModal.whatsapp')}</div>
            </div> : ''}
            {isEmailValid || isSuperAdmin ? <div onClick={() => onSelectedMessageTypeChange(MessageTypes.EMAIL)}
                 className={`messageTypeButton ${selectedMessagingTypes.includes(MessageTypes.EMAIL) ? 'selected' : ''}`}>
                <div className="messageTypeIcon">{<MailOutlineIcon width="32px" height="32px"/>}</div>
                <div className="messageTypeText">{i18n.translate('sendSMSModal.email')}</div>
            </div> : ''}

        </div>
    </div>
}